import { render, staticRenderFns } from "./PreAreaModal.vue?vue&type=template&id=1f534358&"
import script from "./PreAreaModal.vue?vue&type=script&lang=js&"
export * from "./PreAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f534358')) {
      api.createRecord('1f534358', component.options)
    } else {
      api.reload('1f534358', component.options)
    }
    module.hot.accept("./PreAreaModal.vue?vue&type=template&id=1f534358&", function () {
      api.rerender('1f534358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/modules/PreAreaModal.vue"
export default component.exports